module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAAXNSR0IArs4c6QAAAD1JREFUCB1j+P///wEgxgYOMABFHbDJgMQZQADIQNd9ACwBlUTX7QCXhCqA6T6AIgGVhOl2wJCEKmhAlgAAG9F1EiWfgxkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/385616900272080137.png
// module id = 1K/J
// module chunks = 1